import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap"; 
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function CollectionSoldProperties() {
  const [CollectionSoldProperties, setCollectionSoldProperties] = useState({});

  useEffect(() => {
    const fetchCollectionSoldProperties = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/collection/completed-properties-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCollectionSoldProperties(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCollectionSoldProperties();
  }, []);

  const cards = CollectionSoldProperties.card_content
    ? JSON.parse(CollectionSoldProperties.card_content)
    : [];

  return (
    <section className="collection-sold-properties-sec">
      <Container fluid>
        <div className="collection-sold-properties-div row">
          {cards.map((card, index) => (
            <div
              className="sold-property-card col-md-4"
              key={index}
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <Link to={`/properties${card.property_link}`}>
                <img
                  src={`${apiUrl.apiUrl}/${card.image}`}
                  className="img-fluid"
                  alt={card.property_name}
                />
                <div className="sold-propery-content">
                  <h3 className="goldenColor luxury-font">
                    {card.property_name}
                  </h3>
                  <p>{card.property_description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default CollectionSoldProperties;
